import { groupDefaultUploadLocationFolderName } from './selectedFolderSelectors.locstring.json';
import { defaultUploadLocationFolderName } from 'owa-locstrings/lib/strings/defaultuploadlocationfoldername.locstring.json';
import loc, { isStringNullOrWhiteSpace } from 'owa-localize';
import { assertNever } from 'owa-assert';

import { getStore } from '../store/store';
import { getUploadFolder } from 'owa-attachments-upload-folder';
import { isGroupProviderViewState, isOneDriveProViewState } from '../utils/typeGuards';

export function getSelectedFolderName(): string | null {
    const { providerViewState } = getStore();

    if (isOneDriveProViewState(providerViewState)) {
        const uploadFolder = getUploadFolder();

        return uploadFolder && !isStringNullOrWhiteSpace(uploadFolder.folderName)
            ? uploadFolder.folderName
            : loc(defaultUploadLocationFolderName);
    } else if (isGroupProviderViewState(providerViewState)) {
        const uploadFolder = getUploadFolder(providerViewState.groupMailboxId);

        return uploadFolder ? uploadFolder.folderName : loc(groupDefaultUploadLocationFolderName);
    }

    return assertNever(providerViewState);
}
